import React from 'react';
import { Trans } from 'react-i18next';
function appMessage(props) {
    if (props.message === '') {
        return React.createElement(React.Fragment, null);
    }
    else if (props.element) {
        return (React.createElement("div", { className: 'row' },
            React.createElement("div", { className: 'small-12 large-10 large-centered columns helper-margin-top-s', id: 'message-container' },
                React.createElement("div", { className: "alert-box " + (props.success ? 'success' : 'alert') + " radius" }, props.element))));
    }
    else {
        return (React.createElement("div", { className: 'row' },
            React.createElement("div", { className: 'small-12 large-10 large-centered columns helper-margin-top-s', id: 'message-container' },
                React.createElement("div", { className: "alert-box " + (props.success ? 'success' : 'alert') + " radius" },
                    React.createElement(Trans, null, props.message)))));
    }
}
export default appMessage;
